module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"header":"Link de pagamento"},"en-US":{"header":"Payment Link"}}')
  delete Component.options._Ctor
}
